module.exports = __webpack_public_path__ + "static/media/linkedin.60b8d853.svg";